import React, { useEffect } from 'react';
import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';
import { Spinner } from 'react-bootstrap';

const LazyMonacoEditor = React.lazy(() => import('@monaco-editor/react'));

const MonacoEditorComponent = (props) => {
  useEffect(() => {
    loader.config({ monaco });
  }, []);

  return (
    <React.Suspense fallback={<div className='d-flex justify-content-center align-items-center'><Spinner size='sm' /></div>}>
      <LazyMonacoEditor {...props} />
    </React.Suspense>
  );
};

export default MonacoEditorComponent;
